import { useMediaQuery } from './use-media-query'

export const DESKTOP_MIN_WIDTH_PX = 768

export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`

export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_MEDIA_QUERY)
}
